import React, { Fragment } from 'react';

function ThankYou() {
  return (
    <Fragment>
      <main id="thankyou">
        <div className="container">
          <h1>Kiitos!</h1>
          <p>Suurkiitokset palautteestasi! Se auttaa meitä tekemään palveluistamme parempia.</p>
        </div>
      </main>
    </Fragment>
  );
}

export default ThankYou;
